import { User } from "src/state/types";

/**
 * The session as `localStorage` holds it right now.
 *
 * `localStorage` is shared by every tab of the browser, so this - not a tab's
 * in-memory `tokenRef` - is where a token another tab has just been handed
 * shows up first. `userState` writes it (base64 of URI-encoded JSON); this is
 * the one reader outside the provider.
 */
export function readStoredUser(): User | null {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;

    const user = JSON.parse(decodeURIComponent(window.atob(raw)));
    return user && typeof user === "object" && typeof user.token === "string" ? user : null;
  } catch (error) {
    return null;
  }
}

export function readStoredToken(): string | null {
  return readStoredUser()?.token ?? null;
}
